export const getFilterId = (entityId: string) =>
  `crm-collection-chooser-filter-${entityId.slice(0, 7)}`
